/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebInstytucjeNipPlikiPlzIdUpoGet$Params {
  nip: string;
  plzId: number;
}

export function apiWebInstytucjeNipPlikiPlzIdUpoGet(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipPlikiPlzIdUpoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipPlikiPlzIdUpoGet.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.path('plzId', params.plzId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiWebInstytucjeNipPlikiPlzIdUpoGet.PATH = '/api/web/instytucje/{nip}/pliki/{plzId}/upo';
